module.exports = __webpack_public_path__ + "static/media/fire.8c81f27b.svg";